import { makeStyles, theme } from "cdh-data-portal-theme"

export const useStyles = makeStyles()(() => ({
  code: {
    "&&": {
      color: theme.textColors.primary,
      fontSize: 32,
      letterSpacing: 4,
    },
  },
  codeContainer: {
    alignItems: "center",
    backgroundColor: theme.colors.grayBackground,
    borderRadius: 8,
    display: "flex",
    flexDirection: "column",
    gap: 4,
    padding: "16px 32px",
  },
  container: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    maxWidth: 420,
    textAlign: "center",
  },
  countdown: {
    "&&": {
      color: theme.textColors.primaryLighter,
    },
  },
  root: {
    alignItems: "center",
    backgroundColor: theme.colors.globalBackgroundLight,
    display: "flex",
    height: "100vh",
    justifyContent: "center",
    width: "100vw",
  },
  subtitle: {
    "&&": {
      marginBottom: 8,
    },
  },
  title: {
    "&&": {
      color: theme.textColors.primary,
      margin: "16px 0 0 0",
    },
  },
}))
